import React from "react";

interface Props {
  data: {
    label: string;
    value: any;
  }[];
}

export const HorizontalData = React.memo((props: Props) => {
  return (
    <div className="flex flex-col sm:flex-row w-full p-2 sm:p-7 md:p-4 bg-white  rounded-xl drop-shadow-none mb-1 sm:mb-10">
      {props?.data?.map((item, index) => (
        <div
          className={`${
            props?.data?.length - 1 === index
              ? "flex flex-1 sm:flex-col justify-between items-center sm:items-center border-gray-border h-full p-2 sm:py-0"
              : "flex flex-1 sm:flex-col justify-between items-center  border-b sm:border-b-0 sm:border-r border-gray-border h-full p-2 sm:py-0"
          }`}
        >
          <div className="flex items-center mb-1">
            <p className="font-satoshi text-center text-2xl text-dark font-bold">
              {item?.value}
            </p>
          </div>
          <p className="font-satoshi font-medium text-sm text-gray-text ml-2 text-center sm:ml-0">
            {item?.label}
          </p>
        </div>
      ))}
    </div>
  );
});
